var APPLICATION_STRATEGY_MAP, OrganizationInfo;

APPLICATION_STRATEGY_MAP = {
  '审核后加入': 'must_approved',
  '自动加入': 'auto_approved',
  '禁止申请': 'closed'
};

import OrganizationsTab from 'trunks/vue/admin/components/organizations/organization_tab.js';

import UserOrganizationsContainer from '../users_organizations_container.js';

import transformOrganizationModal from 'trunks/vue/admin/compositions/organizations/responses/transform_organization_modal.js';

import OptionsSelect from 'trunks/vue/admin/components/options_select.js';

import OrganizationState from 'trunks/vue/admin/components/organizations/organization_state.js';

export default OrganizationInfo = Vue.extend({
  components: {
    "organization-tab": OrganizationsTab,
    "user-organization-container": UserOrganizationsContainer,
    'options-select': OptionsSelect
  },
  props: {
    organization: {
      type: Object,
      required: true
    },
    bindedMembersCount: {
      type: Number
    },
    membersCount: {
      type: Number
    },
    applyLink: {
      type: String
    },
    organizationApplicationsCount: {
      type: Number
    },
    activeTab: {
      type: String
    },
    editOrganizationFunc: {
      type: Function,
      required: true
    },
    editProfileFunc: {
      type: Function,
      required: true
    }
  },
  data: function() {
    return {
      description: this.organization.description,
      qrCodeData: '',
      profileFields: [],
      organizationState: OrganizationState
    };
  },
  template: `<user-organization-container :title="organization.name" ref="userOrganizationsContainerRef">
  <template slot="content">
    <organization-tab :organizationId="organization.id"
                      :pendingOrganizationApplicationsCount='organizationApplicationsCount'
                      :activeTab="activeTab" />

    <div class="organization-content">
      <div class="organization-details">
        <div class="details-header">
          <div class="details-title">组织简介</div>
          <div class="details-edit" @click="editOrganizationFunc(organization)">编辑</div>
        </div>

        <div class="details-content">
          <article v-if="description">
            <div v-html="description"></div>
          </article>
          <div class="blankslate" v-else>
            <p>暂无简介</p>
          </div>
        </div>
      </div>

      <div class="organization-info">
        <div class="info-box">
          <div class="info-box-item">
            <div class="title">组织信息</div>
          </div>
          <div class="info-box-item">
            <div class="title">组织创建者</div>
            <div class="content">
              <div class="name">{{ organization.founder.name }}</div>
              <div class="transfer-organization" @click="transformOrganization">转移</div>
            </div>
          </div>
          <div class="info-box-item">
            <div class="title">成员加入策略</div>
            <div class="content">
              <options-select :options='applicationStrategyOptions'
                              :initSelectedOption='initialApplicationStrategySelectedOption'
                              :popoverPropsData="{ position: 'bottom center', caret: true, blockContent: false }"
                              :canCancelSingleSelect='false'
                              @valueChange='valueChange'
                              ref='optionsSelectRef' />
            </div>
          </div>
          <div class="info-box-item">
            <div class="title">加入组织二维码</div>
            <div class="content">
              <img class="qrcode" :src="qrCodeData"/>
            </div>
          </div>
          <div class="info-box-item">
            <div class="title">加入组织链接</div>
            <div class="content">{{ applyLink }}</div>
          </div>
          <div class="info-box-item">
            <div class="title">组织总人数</div>
            <div class="content">
              <div class="total">
                <span>{{ membersCount }}</span>
                <span>人，已经绑定</span>
                <span>{{ bindedMembersCount }}</span>
              </div>
              <div class="helper-text">（包含所有下级组织）</div>
            </div>
          </div>
        </div>

        <div class="info-box list-item divided">
          <div class="info-box-item">
            <div class="title">其他信息</div>
            <div class="details-edit" @click="editProfileFunc(organization)">编辑</div>
          </div>
          <div class="info-box-item" v-for='field in profileFields'>
            <div class="title">{{ field.title }}</div>
            <div class="block-content">
              <div class="content" v-for='entry in field.entries'>
                <div class="rating-list" v-if='field.type === "Field::Rating"'>
                  <div class="rating-item justify-box"
                      v-for='i in field.maximum'
                      :key='i'
                      :class="{ active: i <= entry.value }"
                      @click='selectValue(i)'>
                    <i class="text-strong rating-item-icon" :class="[ i <= entry.value? 'slp-star' : 'slp-star-o' ]"></i>
                  </div>
                </div>
                <div v-else-if='field.type === "Field::File"'>
                  <img v-if="entry.attachment.extension == 'image'" :src='previewUrl(entry.attachment)' class="qrcode"/>
                  <file-icon v-else :type='entry.attachment.extension' size='small' />
                </div>
                <div v-else>{{ entry.value }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </template>
</user-organization-container>`,
  mounted: function() {
    return QRCode.toDataURL(this.applyLink, (err, link) => {
      return this.qrCodeData = link;
    });
  },
  created: function() {
    return this._parseProfileFields();
  },
  computed: {
    applicationStrategyOptions: function() {
      return _.map(_.keys(APPLICATION_STRATEGY_MAP), function(item) {
        return new Skylark.App.Model.FieldOption({
          id: Skylark.Helpers.Utilities.uuid(),
          value: item
        });
      });
    },
    initialApplicationStrategySelectedOption: function() {
      return _.find(this.applicationStrategyOptions, (option) => {
        return APPLICATION_STRATEGY_MAP[option.value] === this.organization.application_strategy;
      });
    }
  },
  watch: {
    'organizationState.name': function() {
      return this.organization.name = this.organizationState.name;
    }
  },
  methods: {
    previewUrl: function(attachment) {
      return `/attachments/${attachment.id}/download_url`;
    },
    transformOrganization: function() {
      return new transformOrganizationModal({
        el: Skylark.Helpers.Utilities.getOrCreateCleaningElementByIdForVue('response_create_member_modal_container'),
        propsData: {
          organization: this.organization,
          updateOrganizationFounder: (user) => {
            this.organization.founder.id = user.id;
            return this.organization.founder.name = user.name;
          }
        }
      });
    },
    valueChange: function(options) {
      this.organization.application_strategy = APPLICATION_STRATEGY_MAP[options[0].label];
      return this._updateApplicationStrategy();
    },
    _updateApplicationStrategy: function() {
      return Skylark.Libs.Ajax.put(`/admin/organizations/${this.organization.id}`, {
        contentType: 'application/json; charset=utf-8',
        responseType: 'json',
        data: {
          organization: {
            application_strategy: this.organization.application_strategy
          }
        }
      });
    },
    _parseProfileFields: function() {
      return Skylark.Libs.Ajax.get("/admin/organization_profile/schema.json", {
        responseType: 'json',
        success: (profileSchema) => {
          var sortedFields;
          sortedFields = _.sortBy(profileSchema.fields, function(field) {
            return field.position;
          });
          return this.profileFields = _.map(sortedFields, (field) => {
            var ref;
            field.entries = [];
            _.each((ref = this.organization.profile_submission) != null ? ref.entries : void 0, function(entry) {
              if (entry.field_id === field.id) {
                return field.entries.push(entry);
              }
            });
            return field;
          });
        }
      });
    }
  }
});
